import axios from 'axios'
import jsCookie from 'js-cookie'
import { location } from '@/infrastructure/Configuration'
import DestinationService from '@/services/DestinationService'
import HotelService from '@/services/HotelService'
import LoyaltyService from '@/services/LoyaltyService'
import CookieService from '@/services/CookieService'
import TripAdvisorService from '@/services/TripAdvisorService'
import OffersService from '../services/offers/OffersService'
import MyReservationsService from '@/services/reservations/MyReservationsService'
import EventsReservationsService from '@/services/reservations/EventsReservationsService'
import TransactionService from '@/services/reservations/TransactionsService'
import ContentService from '@/services/profile/ContentService'
import MemberBenefitsService from '@/services/MemberBenefitsService'
import MultiOffersService from '@/services/offers/MultiOffersService'
import NlpService from '@/services/NlpService'
import ZimbaService from '@/services/ZimbaService'
import TransliterationService from '@/services/TransliterationService'
import DiscoveryService from '@/services/DiscoveryService'
import BookingSummaryService from '@/services/BookingSummaryService'
import DynamicLinkService from '@/services/DynamicLinkService'
import SmartLinkingService from '@/services/SmartLinkingService'

import DnaService from '@/services/DnaService'
import MyAccountService from '@/services/AccountService'

axios.defaults.headers.common['Accept-Language'] = location
axios.defaults.timeout = 30000

export const multiOffersService = new MultiOffersService(axios)
export const destinationService = new DestinationService(axios)
export const hotelService = new HotelService(axios)
export const loyaltyService = new LoyaltyService(axios)
export const contentService = new ContentService(axios)
export const tripAdvisorService = new TripAdvisorService(axios)
export const cookieService = new CookieService({ cookieReader: jsCookie })
export const offersService = new OffersService(
  axios,
  destinationService,
  hotelService,
  loyaltyService
)
export const reservationsService = new MyReservationsService(axios, hotelService)
export const eventsReservationsService = new EventsReservationsService(axios)
export const transactionService = new TransactionService()
export const memberBenefitsService = new MemberBenefitsService(axios)
export const nlpService = new NlpService(axios)
export const zimbaService = new ZimbaService(axios)
export const transliterationService = new TransliterationService(axios)
export const discoveryService = new DiscoveryService(axios)
export const bookingSummaryService = new BookingSummaryService(axios)
export const dnaService = new DnaService()
export const myAccountService = new MyAccountService(axios)
export const dynamicLinkService = new DynamicLinkService(axios)
export const smartLinkingService = new SmartLinkingService(axios)
